import React, { Component } from 'react';
import $ from 'jquery';
import Vas from '../../../Vas';

import '../../../css/CustomerCard.css';

import CustomerModel from '../../../models/Customer';

import { PagingTable } from 'component-lib';
import { RoleConfiguration } from 'utils-lib';
import { ConfirmationsModel, RequestAjaxClass} from 'models-lib';

class CustomerCertificateData extends Component
{
    constructor(props)
    {
        super(props);
        this.state = new CustomerModel([this]);
        this.state.CurrentView = "CustomerData";
        this.state.DocumentList=[];
        this.CustomerId = props.id;
        this.state.Upload=false;
        this.state.Limit = 10;
        this.state.Start = 0;
        this.ConfirmationsModel = new ConfirmationsModel([this]);
        this.GetRequest = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
    }

    componentWillMount(){
        $("#LoadingIcon").removeClass().addClass('loaderSmall');
        this.GetRequest.setApiUrl(Vas.ApiUrl);
        this.GetRequest.setApiKey(Vas.ApiKey);
        this.GetRequest.setAuth(true);
        this.GetRequest.setErrorHandler(()=>{
            $("#LoadingIcon").removeClass().addClass('hide');
        });
        this.ConfirmationsModel.SetRequest(this.GetRequest);
    }

    load(sendData){
        this.ConfirmationsModel.GetConfirmationsByCustomerId(this.CustomerId,sendData);
    }

    Update(observer)
    {
        this.setState({},()=>{
            let me = this;
            if(observer === "Confirmations"){
                if (me.refs.table){
                    me.refs.table.setState({ Data: me.ConfirmationsModel.Confirmations, Count: me.ConfirmationsModel.Count, Limit: me.ConfirmationsModel.Limit, Start: me.ConfirmationsModel.Start, End: me.ConfirmationsModel.Start+me.ConfirmationsModel.Confirmations.length });
                }
                $("#LoadingIcon").removeClass().addClass('hide');
            }
        });
    }

    Upload(){
        Vas.GetView("CustomerCertificateUpload",{CustomerId:this.CustomerId},true);
    }

    render()
    {
        let rights = RoleConfiguration.getRoleConfig();
        let role = localStorage.getItem("vas_role");
        let right = '';
        if (role === "1"){
            if (rights[1]){
                right =  rights[1];
            }
        }
        if (role === "3" || role === "99"){
            if (rights[0]){
               right = rights[0]; 
            }
        }

        let upload='';
        if (this.state.Upload === true){
            upload=(<div
              className={"paymentDetails"}
              id={"uploadDocument"} ></div>);
        } else {
            upload=<td><div></div></td>;
        }

        let searchParamsStrings = [];
        searchParamsStrings.push({ TableColumn: "customerId", SearchValue: this.CustomerId });
        
        $("#Content").css("opacity", "0.4");
        return (
          <div >
            <table style={{ width: '600px' }} >
              <tbody>
                <tr>
                  <td>
                    <PagingTable
                    ErrorHandlingPage={(error)=>{Vas.ErrorHandling(error);}}
                      ref="table"
                      SearchParamsStrings={searchParamsStrings}
                      TableReference={this}
                      DataBaseTable={"B2KundenEigen"}
                      Selectable={false} 
                      Limit={this.state.Limit}
                      Start={this.state.Start}
                      End={this.state.End}
                      Count={this.state.Count} 
                      Columns={[Vas.Resources.Labels["DocumentName"],Vas.Resources.Labels["PFrom"],Vas.Resources.Labels["PTo"],Vas.Resources.Labels["IdNumber"],Vas.Resources.Labels["Action"]]}
                      Keys={["Name","DateFrom","DateTo","IdentificationNumber"]} 
                      Data={this.state.Data} 
                      Download={true} 
                      Add={true}
                      AddClick={()=>{this.Upload();}}
                      Border={false}
                      Right={right}
                      DownloadType={"Verification"}
                      Modus={"DBBus"}
                      ApiURL={Vas.ApiUrl}
                      ApiKey={Vas.ApiKey}
                      Token={localStorage.getItem('vas_token')}
                      LabelPage={Vas.Resources.Labels["Page"]}
                      LabelOf={Vas.Resources.Labels["Of"]}
                      LabelCountPerPage={Vas.Resources.Labels["CountPerPage"]}
                      CWidth={[140,100,100,100]}
                      AddString={Vas.Resources.Labels["Add"]}
                      />
                  </td>
                        
                </tr>
                <tr>{upload}</tr>
              </tbody>
              <tfoot>
                    
              </tfoot>
            </table>
          </div>
        );
    }
}
export default CustomerCertificateData;
